module.exports = __webpack_public_path__ + "static/media/checked.f39eec29.svg";